import { render } from "./TernButtonMain.vue?vue&type=template&id=3124fafa&scoped=true"
import script from "./TernButtonMain.vue?vue&type=script&lang=js"
export * from "./TernButtonMain.vue?vue&type=script&lang=js"

import "./TernButtonMain.vue?vue&type=style&index=0&id=3124fafa&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3124fafa"]])

export default __exports__